<div class="d-flex justify-content-center plain-rounded-card pt-5 pt-md-4 p-4">
	<div class="card card-primary col-sm-12 col-md-8 col-lg-6 px-0">
		<div class="credHeader mb-0 border-rounded-top">
			<img src="assets/img/logo.svg" alt="" />
		</div>
		<div class="card-body scroll-body px-0 py-5 py-1">
			<div id="language-wrap">
				<h3 class="title-main">{{ product?.name }}</h3>
				<app-language-select></app-language-select>
			</div>
			<form [formGroup]="form">
				<div class="formInner">
					<h5>{{ page.purchaserInformation }}</h5>
					<div class="row">
						<div class="col-sm-12 col-lg-6 pl-sm-0 mb-3 mb-md-0 px-0 px-md-2">
							<label>{{ labels.firstName }}</label>
							<div class="input-group">
								<input
									formControlName="firstName"
									type="text"
									class="form-control"
									placeholder="{{ labels.firstName }}"
									[ngClass]="{
										'danger-class': f.firstName.errors && f.firstName.touched,
									}"
								/>
								<div
									*ngIf="f.firstName.errors && f.firstName.touched"
									class="invalid-feedback"
								>
									<div *ngIf="f.firstName.errors.required">
										{{ page.errorFirstNameRequired }}
									</div>
									<div *ngIf="f.firstName.errors.pattern">
										{{ labels.errorNoHTML }}
									</div>
									<div *ngIf="f.firstName.errors.maxlength">
										{{ page.errorFirstNameLength }}
									</div>
								</div>
							</div>
						</div>

						<div class="col-sm-12 col-lg-6 pl-sm-0 px-0">
							<label>{{ labels.lastName }}</label>
							<div class="input-group">
								<input
									formControlName="lastName"
									type="text"
									class="form-control"
									placeholder="{{ labels.lastName }}"
									[ngClass]="{
										'danger-class': f.lastName.errors && f.lastName.touched,
									}"
								/>
								<div
									*ngIf="f.lastName.errors && f.lastName.touched"
									class="invalid-feedback"
								>
									<div *ngIf="f.lastName.errors.required">
										{{ page.errorLastNameRequired }}
									</div>
									<div *ngIf="f.lastName.errors.pattern">
										{{ labels.errorNoHTML }}
									</div>
									<div *ngIf="f.lastName.errors.maxlength">
										{{ page.errorLastNameLength }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex-column formInnerCol mt-3">
						<label>{{ labels.email }}</label>
						<div class="input-group">
							<span class="credIcons">
								<input
									formControlName="email"
									type="email"
									maxlength="320"
									name="email"
									class="form-control"
									aria-describedby="emailHelp"
									[ngClass]="{
										'danger-class': f.email.errors && f.email.touched,
									}"
									placeholder="{{ labels.email }}"
								/>
								<button disabled type="button">
									<i class="fas fa-user"></i>
								</button>
							</span>
							<div
								*ngIf="f.email.errors && f.email.touched"
								class="invalid-feedback"
							>
								<div *ngIf="f.email.errors.required">
									{{ page.errorEmailRequired }}
								</div>
								<div *ngIf="f.email.errors.pattern">
									{{ labels.errorEmail }}
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="product?.maxUsers > 1" formArrayName="students">
						<h5>{{ page.studentInformation }}</h5>
						<div
							*ngFor="let student of students.controls; let i = index"
							class="col-12"
						>
							<div id="student-{{ i }}" [formGroupName]="i">
								<div class="row">
									<div
										class="col-sm-12 col-lg-6 pl-sm-0 mb-3 mb-md-0 px-0 px-md-2"
									>
										<label>{{ labels.firstName }}</label>
										<div class="input-group">
											<input
												formControlName="firstName"
												type="text"
												class="form-control"
												placeholder="{{ labels.firstName }}"
												[ngClass]="{
													'danger-class':
														student.controls.firstName.errors &&
														student.controls.firstName.touched,
												}"
											/>
											<div
												*ngIf="
													student.controls.firstName.errors &&
													student.controls.firstName.touched
												"
												class="invalid-feedback"
											>
												<div *ngIf="student.controls.firstName.errors.required">
													{{ page.errorFirstNameRequired }}
												</div>
												<div *ngIf="student.controls.firstName.errors.pattern">
													{{ labels.errorNoHTML }}
												</div>
												<div
													*ngIf="student.controls.firstName.errors.maxlength"
												>
													{{ page.errorFirstNameLength }}
												</div>
											</div>
										</div>
									</div>

									<div class="col-sm-12 col-lg-6 pl-sm-0 px-0">
										<label>{{ labels.lastName }}</label>
										<div class="input-group">
											<input
												formControlName="lastName"
												type="text"
												class="form-control"
												placeholder="{{ labels.lastName }}"
												[ngClass]="{
													'danger-class':
														student.controls.lastName.errors &&
														student.controls.lastName.touched,
												}"
											/>
											<div
												*ngIf="
													student.controls.lastName.errors &&
													student.controls.lastName.touched
												"
												class="invalid-feedback"
											>
												<div *ngIf="student.controls.lastName.errors.required">
													{{ page.errorLastNameRequired }}
												</div>
												<div *ngIf="student.controls.lastName.errors.pattern">
													{{ labels.errorNoHTML }}
												</div>
												<div *ngIf="student.controls.lastName.errors.maxlength">
													{{ page.errorLastNameLength }}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="flex-column formInnerCol mt-3">
									<label>{{ labels.email }}</label>
									<div class="input-group">
										<span class="credIcons">
											<input
												formControlName="email"
												type="email"
												maxlength="320"
												name="email"
												class="form-control"
												aria-describedby="emailHelp"
												[ngClass]="{
													'danger-class':
														student.controls.email.errors &&
														student.controls.email.touched,
												}"
												placeholder="{{ labels.email }}"
											/>
											<button disabled type="button">
												<i class="fas fa-user"></i>
											</button>
										</span>
										<div
											*ngIf="
												student.controls.email.errors &&
												student.controls.email.touched
											"
											class="invalid-feedback"
										>
											<div *ngIf="student.controls.email.errors.required">
												{{ page.errorEmailRequired }}
											</div>
											<div *ngIf="student.controls.email.errors.pattern">
												{{ labels.errorEmail }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row add-remove-user">
							<app-button
								*ngIf="students.controls.length < product?.maxUsers - 1"
								class="add-user"
								(click)="addUser()"
							>
								{{ page.addStudent }}
							</app-button>
							<app-button
								*ngIf="students.controls.length > 1"
								class="remove-user"
								(click)="removeUser()"
							>
								{{ page.removeStudent }}
							</app-button>
						</div>
					</div>

					<h5>{{ page.paymentInformation }}</h5>
					<div class="flex-column formInnerCol mt-3">
						<label>{{ page.promotionCode }}</label>
						<div class="input-group">
							<span class="credIcons">
								<input
									formControlName="promo"
									type="text"
									maxlength="320"
									name="promo"
									class="form-control"
									aria-describedby="promoHelp"
									[ngClass]="{
										'danger-class': f.promo.errors && f.promo.touched,
									}"
									placeholder="{{ page.promotionCode }}"
									(focus)="onPromoFocus()"
									(blur)="onPromoBlur()"
								/>
							</span>
							<div *ngIf="!!page.promoDiscount">
								{{ page.promoDiscount }}
							</div>
							<div *ngIf="!!page.promoError" class="invalid-feedback">
								{{ page.promoError }}
							</div>
						</div>
					</div>
					<div id="payment-element"></div>

					<div class="col-12 mb-3 c-form">
						<div class="form-group pt-3">
							<div class="row">
								<input
									class="form-check-input"
									type="checkbox"
									id="gridCheck"
									formControlName="check"
								/>
								<label class="form-check-label pt-1 d-inline" for="gridCheck">
									<div [innerHTML]="page.policies"></div>
								</label>
							</div>
							<div
								*ngIf="f.check.errors && f.check.touched"
								class="invalid-feedback"
							>
								<div *ngIf="f.check.errors.required">
									{{ page.acceptPolicies }}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					class="registerBtn border-top btn-c d-flex align-items-center justify-content-center"
				>
					<app-button [loading]="loading" class="mt-4" (click)="onSubmit()">
						{{ page.pay }}
					</app-button>
				</div>
			</form>

			<div class="login-dont-have-text">
				<span
					>{{ page.alreadyHaveAnAccount }}
					<a routerLink="/login" routerLinkActive="active" class="link">{{
						page.login
					}}</a></span
				>
			</div>
		</div>
	</div>
</div>
